import React from 'react';
import { range, pairs } from 'd3-array';
import { scaleLinear } from 'd3-scale';
import { area, curveStepBefore } from 'd3-shape'
import colorFn from "./colorFn"

const localColorFn = key => {
  if (key === "SUSCEPTIBLE") {
    return "#ddd"
  } else {
    return colorFn(key)
  }
}

const height = 62;

const PopulationDynamics = ({ 
  populationTimeSeries, 
  statesList,
  changeDays
}) => {
  const keys = statesList.map(s => s.key)

  const populationTotal = keys.reduce((memo, key) => {
    const portion = (populationTimeSeries[0][key]) ? populationTimeSeries[0][key] : 0
    return memo + portion
  }, 0)

  const heightScale = scaleLinear().domain([0, populationTotal]).range([0, height])

  const simulationLength = populationTimeSeries.length + 1
  const widthScale = scaleLinear()
    .domain([0, populationTimeSeries.length + 1])
    .range([0, Math.min(simulationLength * 5, Math.min(600, window.innerWidth))])

  const areaFn = {}
  
  statesList.slice(0).forEach((state, i, array) => {
    areaFn[state.key] = area()
      .x((d, n) => { return widthScale(n) })
      .y0((d) => {
        const stackedValue = array.slice(0, i).reduce((memo, s) => {
          return memo + ((d[s.key]) ? d[s.key] : 0)
        }, 0)

        return heightScale(stackedValue)
      })
      .y1((d) => {
        const stackedValue = array.slice(0, i + 1).reduce((memo, s) => {
          return memo + d[s.key]
        }, 0)

        return heightScale(stackedValue)
      })
      .curve(curveStepBefore)
  })

  return (
    <div>
      <div className="legend-wrapper">
        {statesList.map((s) => {
          const count = populationTimeSeries[populationTimeSeries.length - 1][s.key]

          return <span className="legend-item" key={s.key}>
            <span className="legend-count" style={{ background: colorFn(s.key) }}>{count}</span>{s.label}
          </span>
        })}
      </div>
      <svg className="population-graph" width="100%" height={height + 45}>
        <line y1="64.5" y2="64.5" x2="600" stroke="#333" />
        {range(Math.floor(populationTimeSeries.length / 7) + 1).map((i) => {
          return <g key={i} transform={`translate(${widthScale(i * 7)}, 0)`}>
            <line y1="65" y2="70" stroke="#333" />
            <text className="axis-label" textAnchor={(i === 0) ? "start" : "middle"} y="83">{i}</text>
          </g>
        })}
        <text className="axis-label" textAnchor={"start"} fontWeight="bold" y="96">Week</text>

        {statesList.map((key, i) => {
          return <path 
            key={i}
            d={areaFn[key.key](populationTimeSeries)} 
            fill={localColorFn(key.key)}
          />
        })}

        {(changeDays) ? 
        <g>
          {changeDays.map((d) => {
            const x = widthScale(d)
            return <line key={`line-${d}`} y2="65" x1={x} x2={x} stroke="black" />
          })}
          {pairs(changeDays).filter((p, i) => i % 2 === 0).map((p, i) => {
            return <React.Fragment key={`bar-${i}`} >
              <rect 
                x={widthScale(p[0])} 
                y="65" 
                height={5} 
                width={widthScale(p[1]) - widthScale(p[0])} 
                style={{ fill: "url(#diagonal-stripe-2)" }} 
              />
            </React.Fragment>
          })}
            
        </g> : null}
      </svg>
    </div>
  );
};

export default PopulationDynamics;